var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('h5',{staticClass:"d-inline"},[_vm._v("Disponibilità per la materia: ")]),_c('h5',{staticClass:"d-inline",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.nome))])])
}
var staticRenderFns = []

export { render, staticRenderFns }